import { Field } from 'formik'
import { FC } from 'react'
import { useTranslation } from 'next-i18next'
import { UserProfileYearsOfExperience } from '@/types'
import { CheckboxGroup } from '@/components/organisms/CheckboxGroup'

export const YearsOfExperienceCheckboxField: FC = () => {
  const { t } = useTranslation(['companies-users-[id]'])

  return (
    <CheckboxGroup>
      <label>
        <Field type='checkbox' name='yearsOfExperience' value={UserProfileYearsOfExperience.LESS_THAN_1_YEAR} />
        {t(UserProfileYearsOfExperience.LESS_THAN_1_YEAR)}
      </label>
      <label>
        <Field type='checkbox' name='yearsOfExperience' value={UserProfileYearsOfExperience.ONE_YEAR_OR_MORE} />
        {t(UserProfileYearsOfExperience.ONE_YEAR_OR_MORE)}
      </label>
      <label>
        <Field type='checkbox' name='yearsOfExperience' value={UserProfileYearsOfExperience.TWO_YEARS_OR_MORE} />
        {t(UserProfileYearsOfExperience.TWO_YEARS_OR_MORE)}
      </label>
      <label>
        <Field type='checkbox' name='yearsOfExperience' value={UserProfileYearsOfExperience.THREE_YEARS_OR_MORE} />
        {t(UserProfileYearsOfExperience.THREE_YEARS_OR_MORE)}
      </label>
      <label>
        <Field type='checkbox' name='yearsOfExperience' value={UserProfileYearsOfExperience.FOUR_YEARS_OR_MORE} />
        {t(UserProfileYearsOfExperience.FOUR_YEARS_OR_MORE)}
      </label>
      <label>
        <Field type='checkbox' name='yearsOfExperience' value={UserProfileYearsOfExperience.FIVE_YEARS_OR_MORE} />
        {t(UserProfileYearsOfExperience.FIVE_YEARS_OR_MORE)}
      </label>
      <label>
        <Field type='checkbox' name='yearsOfExperience' value={UserProfileYearsOfExperience.SIX_YEARS_OR_MORE} />
        {t(UserProfileYearsOfExperience.SIX_YEARS_OR_MORE)}
      </label>
      <label>
        <Field type='checkbox' name='yearsOfExperience' value={UserProfileYearsOfExperience.SEVEN_YEARS_OR_MORE} />
        {t(UserProfileYearsOfExperience.SEVEN_YEARS_OR_MORE)}
      </label>
      <label>
        <Field type='checkbox' name='yearsOfExperience' value={UserProfileYearsOfExperience.EIGHT_YEARS_OR_MORE} />
        {t(UserProfileYearsOfExperience.EIGHT_YEARS_OR_MORE)}
      </label>
      <label>
        <Field type='checkbox' name='yearsOfExperience' value={UserProfileYearsOfExperience.NINE_YEARS_OR_MORE} />
        {t(UserProfileYearsOfExperience.NINE_YEARS_OR_MORE)}
      </label>
      <label>
        <Field type='checkbox' name='yearsOfExperience' value={UserProfileYearsOfExperience.TEN_YEARS_OR_MORE} />
        {t(UserProfileYearsOfExperience.TEN_YEARS_OR_MORE)}
      </label>
    </CheckboxGroup>
  )
}
